export const MAPBOX_ACCESS_TOKEN = 'pk.eyJ1IjoiZWFydGhwYmMiLCJhIjoiY2x1dGRiMGU4MDdrdjJsb2ducG5pbG41ayJ9.XiX9hVsMSiOXSPf78V3dag'

export const MAPBOX_API = {
  TILEQUERY: 'https://api.mapbox.com/v4/mapbox.mapbox-terrain-v2/tilequery',
  GEOCODING: 'https://api.mapbox.com/geocoding/v5/mapbox.places',
  DIRECTIONS: 'https://api.mapbox.com/directions/v5/mapbox',
  STATIC: 'https://api.mapbox.com/styles/v1/mapbox'
}

export const DEFAULT_MAP_OPTIONS = {
  center: [-91.874, 42.76],
  zoom: 4,
  style: 'mapbox://styles/mapbox/streets-v11'
}

export default MAPBOX_ACCESS_TOKEN
